import _ from 'lodash';

// const APP_ENV = 'dev';
const APP_ENV = process?.env?.REACT_APP_ENV;
// const APP_ENV = 'prod';

const envOverrides = require(`./${APP_ENV}`);
export default _.merge({}, envOverrides);
